module.exports = __webpack_public_path__ + "static/media/Temperature_mode_RO.1f5c5ec0.pdf";